import React, { Fragment } from "react";
import { connect } from "react-redux";
import GeneralInquiries from "../components/GeneralInquiries";
import MerchantInquiries from "../components/MerchantInquiries";
import CustomerInquiries from "../components/CustomerInquiries";
import {
  requestInquiry,
  updateInquiry,
  deleteInquiry,
} from "../actions/inquiryAction";
import Spinner from "../components/layout/Spinner";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Badge from "react-bootstrap/Badge";
import moment from "moment";
import { API_ROOT } from "../components/utils/api-config";

class InquiryContainer extends React.Component {
  constructor(props) {
    super(props);

    // console.log(props);
  }
  componentDidMount() {
    this.props.requestInquiry();
  }

  handleEditInquiry = (id) => {
    const formData = new FormData();
    formData.append("inquery[id]", id);
    formData.append("inquery[user_id]", this.props.user.id);
    this.props.updateInquiry(id, formData);
  };
  handleDeleteInquiry = (id) => {
    this.props.deleteInquiry(id);
    this.props.requestInquiry();
  };
  render() {
    const todayGeneral =
      this.props.inquiries &&
      this.props.inquiries.general_inquiries.filter((inq) => {
        return (
          moment(inq.created_at).format("YYYY-MM-DD") ==
            moment(Date.now()).format("YYYY-MM-DD") && !inq.responded
        );
      });
    const todayMerchant =
      this.props.inquiries &&
      this.props.inquiries.merchant_inquiries.filter((inq) => {
        return (
          moment(inq.created_at).format("YYYY-MM-DD") ==
            moment(Date.now()).format("YYYY-MM-DD") && !inq.responded
        );
      });
    const todayCustomer =
      this.props.inquiries &&
      this.props.inquiries.customer_inquiries.filter((inq) => {
        return (
          moment(inq.created_at).format("YYYY-MM-DD") ==
            moment(Date.now()).format("YYYY-MM-DD") && !inq.responded
        );
      });
    const { loading, inquiries } = this.props;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <Tab.Container
            mountOnEnter
            unmountOnExit
            id="left-tabs-example"
            defaultActiveKey="customer"
          >
            Inquiries
            <Row>
              <Col sm={2} className="pt-5">
                <Nav variant="tabs" className="flex-column">
                  <Nav.Item>
                    <Nav.Link eventKey="customer">
                      Customer{" "}
                      {todayCustomer.length > 0 && (
                        <Badge variant="danger">
                          {todayCustomer.length} new
                        </Badge>
                      )}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="general">
                      General{" "}
                      {todayGeneral.length > 0 && (
                        <Badge variant="danger">
                          {todayGeneral.length} new
                        </Badge>
                      )}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="merchant">
                      Merchant{" "}
                      {todayMerchant.length > 0 && (
                        <Badge variant="danger">
                          {todayMerchant.length} new
                        </Badge>
                      )}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col sm={10}>
                <div className="container-fluid">
                  <Tab.Content>
                    <Tab.Pane eventKey="general">
                      <GeneralInquiries
                        inquiries={inquiries.general_inquiries}
                        handleEditInquiry={this.handleEditInquiry}
                        handleDeleteInquiry={this.handleDeleteInquiry}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="merchant">
                      <MerchantInquiries
                        inquiries={inquiries.merchant_inquiries}
                        handleEditInquiry={this.handleEditInquiry}
                        handleDeleteInquiry={this.handleDeleteInquiry}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="customer">
                      <CustomerInquiries
                        inquiries={inquiries.customer_inquiries}
                        handleEditInquiry={this.handleEditInquiry}
                        handleDeleteInquiry={this.handleDeleteInquiry}
                      />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Col>
            </Row>
          </Tab.Container>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  inquiries: state.requestInquiry.inquiries,
  loading: state.requestInquiry.loading,
  user: state.user.currentUser.currentUser,
});
const mapDispatchToProps = (dispatch) => ({
  requestInquiry: () => dispatch(requestInquiry()),
  updateInquiry: (id, formData) => dispatch(updateInquiry(id, formData)),
  deleteInquiry: (id) => dispatch(deleteInquiry(id)),
});
export default connect(mapStateToProps, mapDispatchToProps)(InquiryContainer);
